import React, {createContext, useContext} from 'react';
import {useFlightCheckObserver} from '../../../Hooks/UserFlow/useFlightCheckObserver';
import {useLogoutObserver} from '../../../Hooks/UserFlow/useLogoutObserver';
import {useOrderObserver} from '../../../Hooks/UserFlow/useOrderObserver';
import {useSaveObserver} from '../../../Hooks/UserFlow/useSaveObserver';
import {useShareObserver} from '../../../Hooks/UserFlow/useShareObserver';
import {useTaopix} from '../TaopixContext';
import useBeforeUnload from '../../../Hooks/useBeforeUnload';
import {usePageCountUpsellObserver} from '../../../Hooks/usePageCountUpsellPrice';
import {useExperience} from '../../Experience/ExperienceProvider';
import use3DProjectObserver from '../../../Hooks/Project/use3DPreviewObserver';
import useQueuedAssetObserver from '../../../Hooks/Assets/useQueuedAssetObserver';
import useAIObserver from '../../../Hooks/Assets/useAIObserver';

export const ObserverContext = createContext({});

const ObserverProvider = ({children}: {children: any}) => {
  const taopix = useTaopix();
  const server = taopix.core.get('server');
  const {experience} = useExperience();

  // Setup observers.
  useBeforeUnload();
  useLogoutObserver(server);
  useFlightCheckObserver(server);
  useOrderObserver(taopix.core, server);
  useSaveObserver(server);
  useShareObserver(server);
  usePageCountUpsellObserver(experience);
  use3DProjectObserver();
  useQueuedAssetObserver();
  useAIObserver();

  return <ObserverContext.Provider value={{}}>{children}</ObserverContext.Provider>;
};

const useObserver = () => {
  const context = useContext(ObserverContext);
  if (undefined === context) {
    throw new Error('useObserver must be used within a ObserverProvider');
  }
  return context;
};

export {ObserverProvider, useObserver};
